import React from 'react';
import './Contact.css';

function Contact() {
    return (
        <>
            <h2>Contact Information</h2>
            <p><strong>Company Name:</strong> OpsMaster Bartłomiej Więckowski</p>
            <p><strong>Address:</strong> ul. Kłobucka 25A / 4, 02-699 Warszawa, Polska</p>
            <p><strong>Email:</strong> <a href="mailto:wieckowski.b@outlook.com" className="email-link">wieckowski.b@outlook.com</a></p>
            <p><strong>NIP:</strong> 5311620575</p>
            <p><strong>REGON:</strong> 540595618</p>
        </>
    );
}

export default Contact;
